import React from 'react'
import styled from 'styled-components';
import Link from 'gatsby-link'
const StyledAlbum = styled.article`

  h1 {
    margin: 0;
  }

  h2 a {
    color: black;
    text-decoration: none;
  }

  .links {
    display: flex;
    flex-direction: column;
  }
  img {
    width: 100%;
    vertical-align: bottom;
  }
`
const MusicLink = ({children, url}) => {
  if(url.trim() === "") {
    return (
      <a style={{textDecoration: 'line-through', color: 'black', opacity: '0.5'}}>{children}</a>
    )
  }
  return (
    <a target="_blank" href={url} rel="noopener noreferrer">{children}</a>
  )
}

const Album = ({node}) => (
	<StyledAlbum>
		<Link to={node.frontmatter.path}>
			<img src={node.frontmatter.img.childImageSharp.resolutions.src} alt=""/>
		</Link>
    <h2><Link to={node.frontmatter.path}>{node.frontmatter.title}</Link></h2>
    <div className="links">
      <MusicLink url={node.frontmatter.applemusUrl}>Apple Music</MusicLink>
      <MusicLink url={node.frontmatter.spotifyUrl}>Spotify</MusicLink>
      <MusicLink url={node.frontmatter.itunesUrl}>iTunes</MusicLink>
      <MusicLink url={node.frontmatter.googleUrl}>Google Play</MusicLink>
      <MusicLink url={node.frontmatter.tidalUrl}>Tidal</MusicLink>
      <MusicLink url={node.frontmatter.soundcloudUrl}>SoundCloud</MusicLink>
    </div>
	</StyledAlbum>
)

export default Album



// WEBPACK FOOTER //
// ./src/components/album.js